var _rect, _circle, _path, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchConnectivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 32,
    viewBox: "0 0 176 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 7.724,
    fill: "#E8DEF1",
    stroke: "#510C76"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.516,
    r: 3.862,
    fill: "#fff",
    stroke: "#510C76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.227 14.201 1.546 2.633",
    stroke: "#510C76",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 22.276,
    r: 0.5,
    fill: "#510C76",
    stroke: "#510C76",
    strokeWidth: 0.931
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#500D76",
    d: "M30 15.5h116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.656 5.719h-25.312L145 23.53h30L172.656 5.72z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175 23.531 172.656 5.72h-25.312L145 23.53m30 0h-30m30 0-.938 3.75h-28.124l-.938-3.75M155.312 25.406h1.407M148.75 25.406h1.406M158.125 25.406h1.406M160.938 25.406h1.406M163.75 25.406h1.406",
    stroke: "#510C76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchConnectivity);
export default __webpack_public_path__ + "static/media/switchConnectivity.e435a2b58d620df02669d1a06547b44a.svg";
export { ForwardRef as ReactComponent };